import React, { useState, useEffect } from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
} from "recharts";
import CustomTooltip from "./CustomTooltip";
import CustomXTick from "./CustomXTick";
import CustomYTick from "./CustomYTick";

export default function CurveChart({
  chartData,
  xDataKey,
  valueDataKey,
  chartType,
}) {
  const [isChartVisible, setIsChartVisible] = useState(true);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(0);

  const toggleCalorieLine = () => {
    setIsChartVisible(!isChartVisible);
  };

  useEffect(() => {
    if (chartData.length > 0) {
      const values = chartData.map((data) => data[valueDataKey]);
      const min = Math.min(...values);
      const max = Math.max(...values);
      setMinValue(min);
      setMaxValue(max);
    }
  }, [chartData, valueDataKey]);

  const orderOfMagnitude = Math.pow(10, Math.floor(Math.log10(maxValue)));
  const extraTick = Math.ceil(maxValue / orderOfMagnitude) * orderOfMagnitude;

  return (
    <>
      <div className="lineChartContainer">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={chartData}
            margin={{
              top: 30,
              right: 30,
              bottom: window.innerWidth > 768 ? 60 : 25,
              left: 20,
            }}
          >
            <CartesianGrid vertical={false} strocke="#FFF" strokeWidth={1} />
            <XAxis
              dataKey={xDataKey}
              tick={<CustomXTick />}
              interval={0}
              tickLine={false}
              axisLine={{ stroke: "#ccc" }}
            />
            <YAxis
              tick={<CustomYTick />}
              axisLine={false}
              tickLine={false}
              domain={[Math.floor(minValue), extraTick]} 
            />
            <Tooltip
              content={<CustomTooltip chartType={chartType} />}
              position={{ x: "right", y: "bottom" }}
            />
            {isChartVisible && (
              <Line
                type="monotone"
                dataKey={valueDataKey}
                stroke="#DDD"
                strokeWidth={2.5}
                dot={{ r: 5, fill: "#DDD" }}
              >
                <LabelList
                  dataKey={valueDataKey}
                  position="top"
                  style={{
                    fill: "#333",
                    textShadow:
                      "-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff",
                    fontSize: "0.5625rem",
                    fontWeight: "800",
                    direction: "ltr",
                  }}
                />
              </Line>
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div
        className="calorieChartLabel centeredFlex"
        onClick={toggleCalorieLine}
        style={isChartVisible ? { opacity: "1" } : { opacity: "0.5" }}
      >
        <p>
          {chartType === "calorie"
            ? "تغییرات کالری"
            : chartType === "weight"
            ? "تغییرات وزن هفته"
            : chartType === "size"
            ? "تغییرات سایز ماهیانه"
            : ""}
        </p>
        <div className="calorieChartLabelDot"></div>
      </div>
    </>
  );
}
